import React, { Component } from 'react'

class ErrorBoundary extends Component {
    state = { error: null, info: null }

    componentDidCatch(error, info) {
        this.setState({
            error: error,
            info: info,
        })
    }

    render() {
        if (this.state.info) {
            return (
                <div>
                    <h1>Something went wrong.</h1>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.info.componentStack}
                    </details>
                </div>
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
